{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "Ogled vseh možnosti",
  "Spoiler_Reveal_Tooltip": "Kliknite za razkritje",
  "VerticalEmbed_Event_Error_Subtitle": "This event has been deleted, replace it with another event.",
  "Viewer_Toolbar_Twitter_Tooltip": "Objavi na Tweeterju",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "Element je strnjen",
  "Spoiler_Reveal_Video_CTA": "Razkrij videoposnetek",
  "VerticalEmbed_Pricing_Plan": "Plan only",
  "Image_Expand_Button_AriaLabel": "Razširi sliko",
  "VerticalEmbed_From_Price": "From",
  "Poll_Viewer_ShowAllResults_CTA": "Ogled vseh rezultatov",
  "Spoiler_Reveal_Image_Placeholder": "Ta slika vsebuje razkritje",
  "VerticalEmbed_Ribbon": "Sale",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "Drsnik iskanja",
  "VerticalEmbed_Error_Subtitle": "This item has been deleted, replace it with another item.",
  "Poll_Viewer_Multiselect_Footer": "Glasujete lahko za več kot en odgovor.",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "Prikaži več kontrolnikov za zvok",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Failed to load service",
  "Fullscreen_Close_Button_AriaLabel": "Zapri",
  "VerticalEmbed_Event_Fetch_Error_Title": "Failed to load event",
  "UploadFile_Viewer_Loader": "Nalaganje {{fileType}}",
  "Polls_Plugin_User_Avatar_Alt": "User avatar",
  "Preview_ReadMore_Label": "Preberi več",
  "Spoiler_Insert_Tooltip": "Razkritje",
  "VerticalEmbed_Product_Fetch_Error_Title": "Failed to load product",
  "Fullscreen_Shrink_Button_AriaLabel": "Shrink",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "Glasnost",
  "Spoiler_Reveal_Gallery_Placeholder": "Ta galerija vsebuje razkritje",
  "Fullscreen_Expand_Button_AriaLabel": "Expand",
  "VerticalEmbed_Bookings_Button": "Rezerviraj zdaj",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "Prekliči utišanje",
  "Spoiler_Reveal_Gallery_CTA": "Razkrij galerijo",
  "Poll_Viewer_ShowLess_CTA": "Prikaži man",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "Utišaj",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+{{anonNumber}} anonimnih",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "Sledi",
  "VerticalEmbed_Products_Button": "Kupi zdaj",
  "Poll_Viewer_Toast_Error_ServerDown": "Ni mogoče vzpostaviti povezave s strežnikom. Poskusite znova pozneje.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "Za ta odgovor je glasovala {{count}} oseba",
  "Poll_Viewer_VoteCount": "Število glasov: {{number}}",
  "VerticalEmbed_Events_Button": "Registrirajte se zdaj",
  "Spoiler_Reveal_Image_CTA": "Razkrij sliko",
  "Poll_Viewer_Toast_Error_Connection": "Ni interneta. Preverite povezavo.",
  "Poll_Viewer_Visibility_Owner_Footer": "Rezultate si lahko ogledate samo vi.",
  "VerticalEmbed_Booking_Error_Title": "Service deleted",
  "VerticalEmbed_Product_Error_Title": "Product deleted",
  "VerticalEmbed_Fetch_Error_Subtitle": "Unable to load item information.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "Število oseb, ki so glasovale za ta odgovor: {{count}}",
  "VerticalEmbed_Event_Error_Title": "Event deleted",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "Element je razširjen",
  "Audio_Plugin_Cover_Alt": "Audio cover",
  "Spoiler_Reveal_Video_Placeholder": "Ta videoposnetek vsebuje razkritje",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "Unable to load product information.",
  "VerticalEmbed_Fetch_Error_Title": "Failed to load item",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "This product has been deleted, replace it with another product.",
  "VerticalEmbed_Booking_Error_Subtitle": "This service has been deleted, replace it with another service.",
  "Preview_SeeFullPost_Label": "Ogled celotne objave",
  "UploadFile_Viewer_Download": "Prenos {{fileType}}",
  "VerticalEmbed_Units_Hour": "{{hours}}h",
  "VerticalEmbed_Units_Minute": "{{minutes}} min",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "Unable to load event information.",
  "VerticalEmbed_Error_Button": "Replace",
  "VerticalEmbed_Error_Title": "Item deleted",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "Unable to load service information.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
